import React from "react";

// Only recognize our completion action, never arbitrary markup or destinations.
export default function SurveyCompletionMessage({ message, onViewResponse }) {
  const content = message.content || "";
  const match = message.sender_type === "system" && content.match(/\nView survey response: https:\/\/app\.ruebarue\.com\/surveys\/([1-9]\d*)\/result\?response=([1-9]\d*)\s*$/);
  if (!match) return <>{content}</>;
  return <>
    {content.slice(0, match.index)}
    <div className="uk-margin-small-top"><button type="button" className="uk-button hms-img-btn" aria-label="View Response" uk-tooltip="View Response" onClick={() => onViewResponse({ surveyId: match[1], responseId: match[2] })}><img src="/images/detail.svg" alt="" /></button></div>
  </>;
}
